import React from "react";
import "./Achievements.css";
import achievementsConfig from "../../../config/home.json"

const achievements = achievementsConfig.achievements;

const Achievements = () => {
const trophies = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/trophy/trophy1.jpg"

  return (
    <div className="achievements-section">
      <h2 className="section-title">Our Achievements</h2>
      <div className="achievements-content">
        {/* Right: Image */}
        <div className="image-container">
          <img src={trophies} alt="Achievements" className="achievement-image" />
        </div>
        
        {/* Left: List of achievements */}
        <ul className="achievements-list">
          {achievements.map((achievement, index) => (
            <li key={index} className="achievement-item">
              {achievement}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Achievements;
